import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IJournalEquipment } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getJournalEquipmentList = (params: IDynamicTableParams) => {
  return instance(true, PPR_API_URL)
    .get<IJournalEquipment[]>('/journalEquipment/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getJournalEquipmentAvailableColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableColumnModel[]>('/journalEquipment/availableColumns')
    .then((response) => response.data);
};

export const getJournalEquipmentAvailableGroupColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableGroupColumnModel[]>('/journalEquipment/availableGroupColumns')
    .then((response) => response.data);
};
